import { useState } from "react";
import ExpandableTable from "../Components/Util/ExpandableTable";
import styles from './LayerSummary.module.css';

const LayerSummary = (props) => {

    const puneLayers = [
        {
          "id": "750286d6-a3d7-46c5-b79f-1d6f0b67acc2",
          "label": "Base layers",
          "parentId": null,
          "children": [
            {
              "id": "525feee6-5b80-466f-943a-c73dc1cb126a",
              "label": "Road",
              "parentId": "750286d6-a3d7-46c5-b79f-1d6f0b67acc2",
              "children": [
                {
                  "id": "c79a789f-4a90-400c-b8a9-73a0896517bb",
                  "label": "State Highway",
                  "parentId": "525feee6-5b80-466f-943a-c73dc1cb126a",
                  "children": [
                    {
                      "id": "9127b960-494c-4e16-b6ca-7e79f359ce64",
                      "label": "Chakan-Alandi Road",
                      "parentId": "c79a789f-4a90-400c-b8a9-73a0896517bb",
                      "children": [],
                      "count": 1.0,
                      "length": 400.58,
                      "area": 3365.0
                    }
                  ],
                  "count": 1.0,
                  "length": 400.58,
                  "area": 3365.0
                },
                {
                  "id": "a83030d6-fcd5-4281-808e-679bcd3a6bba",
                  "label": "Village road",
                  "parentId": "525feee6-5b80-466f-943a-c73dc1cb126a",
                  "children": [
                    {
                      "id": "d9d1cac2-f419-402a-9a29-83d02f257ac8",
                      "label": "DD Mine Road",
                      "parentId": "a83030d6-fcd5-4281-808e-679bcd3a6bba",
                      "children": [],
                      "count": 1.0,
                      "length": 346.62,
                      "area": 2474.11
                    }
                  ],
                  "count": 1.0,
                  "length": 346.62,
                  "area": 2474.11
                }
              ],
              "count": 2.0,
              "length": 747.2,
              "area": 5839.110000000001
            }
          ],
          "count": 2.0,
          "length": 747.2,
          "area": 5839.110000000001
        },
        {
          "id": "7ac824d8-83b6-4b02-9e36-566c33b6b2bf",
          "label": "LULC",
          "parentId": null,
          "children": [
            {
              "id": "5b402e56-a23a-4b8b-a97a-b69e2ba08a46",
              "label": "Residential ",
              "parentId": "7ac824d8-83b6-4b02-9e36-566c33b6b2bf",
              "children": [
                {
                  "id": "f4e5b519-afbe-4ac7-b3f3-120e2b6ec314",
                  "label": "DD_PSA_Res_1",
                  "parentId": "5b402e56-a23a-4b8b-a97a-b69e2ba08a46",
                  "children": [],
                  "count": 0,
                  "length": 0,
                  "area": 21813.6
                }
              ],
              "count": 0,
              "length": 0,
              "area": 21813.6
            },
            {
              "id": "f11127e0-2f05-4165-852b-66863789fe91",
              "label": "Commercial",
              "parentId": "7ac824d8-83b6-4b02-9e36-566c33b6b2bf",
              "children": [
                {
                  "id": "cd5e6b7a-912e-48e0-a611-ee1879b969bc",
                  "label": "DD_PSA_Com_1",
                  "parentId": "f11127e0-2f05-4165-852b-66863789fe91",
                  "children": [],
                  "count": 0,
                  "length": 0,
                  "area": 2501.13
                }
              ],
              "count": 0,
              "length": 0,
              "area": 2501.13
            },
            {
              "id": "bc91df05-fb57-4b2d-ad27-ff1047e9c413",
              "label": "Educational",
              "parentId": "7ac824d8-83b6-4b02-9e36-566c33b6b2bf",
              "children": [
                {
                  "id": "25eeb97c-fe86-4030-9c3e-0381e0f8e8c7",
                  "label": "DD_PSA_Edu_1",
                  "parentId": "bc91df05-fb57-4b2d-ad27-ff1047e9c413",
                  "children": [],
                  "count": 0,
                  "length": 0,
                  "area": 4450.71
                }
              ],
              "count": 0,
              "length": 0,
              "area": 4450.71
            },
            {
              "id": "6aa797cb-0238-4e18-83fb-caeb677d5bf1",
              "label": "Vacant Land",
              "parentId": "7ac824d8-83b6-4b02-9e36-566c33b6b2bf",
              "children": [
                {
                  "id": "c2860a47-8e84-4c5a-b24f-9d5024cb869b",
                  "label": "DD_PSA_VL_1",
                  "parentId": "6aa797cb-0238-4e18-83fb-caeb677d5bf1",
                  "children": [],
                  "count": 0,
                  "length": 0,
                  "area": 27337.77
                }
              ],
              "count": 0,
              "length": 0,
              "area": 27337.77
            },
            {
              "id": "50893138-e762-4d24-aeef-0abf5eef614f",
              "label": "Green Areas",
              "parentId": "7ac824d8-83b6-4b02-9e36-566c33b6b2bf",
              "children": [
                {
                  "id": "f031ff70-c973-4f93-9e32-8a067327158e",
                  "label": "Tree Clad Area ",
                  "parentId": "50893138-e762-4d24-aeef-0abf5eef614f",
                  "children": [
                    {
                      "id": "4d7c7402-fe79-404c-a4ea-d72035d58b26",
                      "label": "DD_PSA_TCA_1",
                      "parentId": "f031ff70-c973-4f93-9e32-8a067327158e",
                      "children": [],
                      "count": 0,
                      "length": 0,
                      "area": 779.36
                    }
                  ],
                  "count": 0,
                  "length": 0,
                  "area": 779.36
                }
              ],
              "count": 0,
              "length": 0,
              "area": 779.36
            },
            {
              "id": "66355194-aabe-4724-93bd-7d5f47f28502",
              "label": "Agricultural Land",
              "parentId": "7ac824d8-83b6-4b02-9e36-566c33b6b2bf",
              "children": [
                {
                  "id": "11fa1075-cbc3-4ec9-bf1c-cbfb94718f0c",
                  "label": "Cropland",
                  "parentId": "66355194-aabe-4724-93bd-7d5f47f28502",
                  "children": [
                    {
                      "id": "19bcda86-a68a-4540-9162-99aaedf17a39",
                      "label": "DD_PSA_CL_1",
                      "parentId": "11fa1075-cbc3-4ec9-bf1c-cbfb94718f0c",
                      "children": [],
                      "count": 0,
                      "length": 0,
                      "area": 86356.2
                    }
                  ],
                  "count": 0,
                  "length": 0,
                  "area": 86356.2
                },
                {
                  "id": "cde22447-0120-4084-a45c-6edc9af670e6",
                  "label": "Fallow land",
                  "parentId": "66355194-aabe-4724-93bd-7d5f47f28502",
                  "children": [
                    {
                      "id": "8954505a-2f06-4a86-8e95-c5129dbfcd96",
                      "label": "DD_PSA_FL_1",
                      "parentId": "cde22447-0120-4084-a45c-6edc9af670e6",
                      "children": [],
                      "count": 0,
                      "length": 0,
                      "area": 4460.54
                    }
                  ],
                  "count": 0,
                  "length": 0,
                  "area": 4460.54
                },
                {
                  "id": "a0dc4c34-03da-404b-b1a6-a4c5e897179b",
                  "label": "Plantations",
                  "parentId": "66355194-aabe-4724-93bd-7d5f47f28502",
                  "children": [
                    {
                      "id": "b32d267b-62a5-43de-890d-04866b2dd840",
                      "label": "DD_PSA_PN_1",
                      "parentId": "a0dc4c34-03da-404b-b1a6-a4c5e897179b",
                      "children": [],
                      "count": 0,
                      "length": 0,
                      "area": 3962.33
                    }
                  ],
                  "count": 0,
                  "length": 0,
                  "area": 3962.33
                }
              ],
              "count": 0,
              "length": 0,
              "area": 94779.06999999999
            },
            {
              "id": "33ad3fa6-c80f-42a8-bb81-64529a89c35d",
              "label": "Wastelands",
              "parentId": "7ac824d8-83b6-4b02-9e36-566c33b6b2bf",
              "children": [
                {
                  "id": "e7eeb807-eead-4bba-a3ab-c6c78ebe9ecc",
                  "label": "Barren",
                  "parentId": "33ad3fa6-c80f-42a8-bb81-64529a89c35d",
                  "children": [
                    {
                      "id": "f9b6fff0-8f0a-4347-8ad4-89657094011b",
                      "label": "DD_PSA_BL_1",
                      "parentId": "e7eeb807-eead-4bba-a3ab-c6c78ebe9ecc",
                      "children": [],
                      "count": 0,
                      "length": 0,
                      "area": 113722.64
                    }
                  ],
                  "count": 0,
                  "length": 0,
                  "area": 113722.64
                }
              ],
              "count": 0,
              "length": 0,
              "area": 113722.64
            },
            {
              "id": "86541282-cacd-4632-bc19-e16909c63a0d",
              "label": "Others",
              "parentId": "7ac824d8-83b6-4b02-9e36-566c33b6b2bf",
              "children": [
                {
                  "id": "1b2418af-3827-423e-ba07-1838ddd48fe0",
                  "label": "Dug Wells",
                  "parentId": "86541282-cacd-4632-bc19-e16909c63a0d",
                  "children": [
                    {
                      "id": "b5ea2324-b415-4cf2-a602-6073bf20594a",
                      "label": "DD_PSA_DW_1",
                      "parentId": "1b2418af-3827-423e-ba07-1838ddd48fe0",
                      "children": [],
                      "count": 5.0,
                      "length": 0,
                      "area": 0
                    }
                  ],
                  "count": 5.0,
                  "length": 0,
                  "area": 0
                }
              ],
              "count": 5.0,
              "length": 0,
              "area": 0
            }
          ],
          "count": 5.0,
          "length": 0,
          "area": 265384.27999999997
        },
        {
          "id": "db2b2af0-8d5d-4893-8e53-e195eb0b5c25",
          "label": "Building Footprints",
          "parentId": null,
          "children": [
            {
              "id": "058adde8-f5ac-40a9-b41d-1534f2ec5055",
              "label": "Building",
              "parentId": "db2b2af0-8d5d-4893-8e53-e195eb0b5c25",
              "children": [
                {
                  "id": "660b706f-f051-4aea-bc77-9962271a94e5",
                  "label": "Independent Building",
                  "parentId": "058adde8-f5ac-40a9-b41d-1534f2ec5055",
                  "children": [
                    {
                      "id": "3b451d28-42b6-4ff4-8970-9428bf4feb3f",
                      "label": "DD_PSA_IB_2",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 277.328
                    },
                    {
                      "id": "17137db8-cd01-4875-b1ac-b3c6a91a73d1",
                      "label": "DD_PSA_IB_3",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 1090.682
                    },
                    {
                      "id": "f8c6b631-818f-454e-b6a0-81e22be12d34",
                      "label": "DD_PSA_IB_4",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 226.961
                    },
                    {
                      "id": "5f22bb39-2fea-4ed6-9e68-525efb09a460",
                      "label": "DD_PSA_IB_5",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 535.634
                    },
                    {
                      "id": "5f8422e5-7025-4e0f-b38c-c03c2440eec4",
                      "label": "DD_PSA_IB_6",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 187.331
                    },
                    {
                      "id": "4ac656d8-e070-48e7-87d4-eb3438e84920",
                      "label": "DD_PSA_IB_7",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 552.618
                    },
                    {
                      "id": "0dcb4abc-0252-4c35-a8eb-71323821a8a0",
                      "label": "DD_PSA_IB_9",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 172.396
                    },
                    {
                      "id": "7349cb61-72d6-4c4c-9b65-a5b31b479059",
                      "label": "DD_PSA_IB_13",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 80.7
                    },
                    {
                      "id": "bc0e7124-1d3c-4e1b-b686-28b0cb07b427",
                      "label": "DD_PSA_IB_18",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 63.817
                    },
                    {
                      "id": "acaf3b56-35d3-4744-a60f-6306ff9ee39d",
                      "label": "DD_PSA_IB_19",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 133.318
                    },
                    {
                      "id": "7fe73d18-3aef-47a9-b409-0dbecfbe8fb7",
                      "label": "DD_PSA_IB_22",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 303.091
                    },
                    {
                      "id": "752b888e-40b9-4d80-8b90-7c675703ee53",
                      "label": "DD_PSA_IB_23",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 108.196
                    },
                    {
                      "id": "f653d81d-5899-4b07-b516-4351e1188c42",
                      "label": "DD_PSA_IB_24",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 60.103
                    },
                    {
                      "id": "4746b601-4065-41b4-b9e0-841a9a9a903c",
                      "label": "DD_PSA_IB_25",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 214.861
                    },
                    {
                      "id": "297b602c-caf4-49bb-b704-49c321389814",
                      "label": "DD_PSA_IB_38",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 110.388
                    },
                    {
                      "id": "1232222c-f6c5-40d7-8c93-1395ef15c2b6",
                      "label": "DD_PSA_IB_47",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 56.878
                    },
                    {
                      "id": "7e96381d-2013-4453-96d2-1e6109ae408a",
                      "label": "DD_PSA_IB_50",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 78.502
                    },
                    {
                      "id": "42aa7d7d-e387-4ab9-a4fd-c66ae94f14df",
                      "label": "DD_PSA_IB_52",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 87.543
                    },
                    {
                      "id": "ffa3d5c4-5eb1-40d0-8a6a-a2b71fb89081",
                      "label": "DD_PSA_IB_53",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 144.559
                    },
                    {
                      "id": "7896ea81-6fe0-48e1-8ca1-e07dfd35e1a9",
                      "label": "DD_PSA_IB_55",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 90.973
                    },
                    {
                      "id": "40100335-8991-493f-a6b9-cb648605513e",
                      "label": "DD_PSA_IB_57",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 78.443
                    },
                    {
                      "id": "33413675-1cc4-40db-8b93-6ca3e5558a23",
                      "label": "DD_PSA_IB_60",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 1333.718
                    },
                    {
                      "id": "c5214374-0598-4b94-88ea-caf0d167768c",
                      "label": "DD_PSA_IB_61",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 252.733
                    },
                    {
                      "id": "4ad62296-6e4b-44af-9b9c-561e3b59b3e1",
                      "label": "DD_PSA_IB_62",
                      "parentId": "660b706f-f051-4aea-bc77-9962271a94e5",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 457.512
                    }
                  ],
                  "count": 24.0,
                  "length": 0,
                  "area": 6698.285000000002
                },
                {
                  "id": "a7ce860d-ffd6-43db-8a0c-544506c88b03",
                  "label": "Multistorey Building",
                  "parentId": "058adde8-f5ac-40a9-b41d-1534f2ec5055",
                  "children": [
                    {
                      "id": "12077b9e-e9a7-4750-a2a1-9300fa2ef5b2",
                      "label": "DD_PSA_MB_1",
                      "parentId": "a7ce860d-ffd6-43db-8a0c-544506c88b03",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 303.642
                    },
                    {
                      "id": "94cb84fc-d281-47af-9cf0-85e944188380",
                      "label": "DD_PSA_MB_8",
                      "parentId": "a7ce860d-ffd6-43db-8a0c-544506c88b03",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 146.542
                    },
                    {
                      "id": "123f460e-dce3-4b2b-ac85-07c18ceda57b",
                      "label": "DD_PSA_MB_10",
                      "parentId": "a7ce860d-ffd6-43db-8a0c-544506c88b03",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 111.156
                    },
                    {
                      "id": "59dbb49f-7689-41c5-abd8-dc084e8d6e5e",
                      "label": "DD_PSA_MB_11",
                      "parentId": "a7ce860d-ffd6-43db-8a0c-544506c88b03",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 109.862
                    },
                    {
                      "id": "8951b2ba-b56b-4d53-80a9-2369b802e908",
                      "label": "DD_PSA_MB_30",
                      "parentId": "a7ce860d-ffd6-43db-8a0c-544506c88b03",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 48.791
                    },
                    {
                      "id": "106d66ec-9f60-4fe5-98c4-ae5177abc8fa",
                      "label": "DD_PSA_MB_54",
                      "parentId": "a7ce860d-ffd6-43db-8a0c-544506c88b03",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 84.566
                    },
                    {
                      "id": "d58aa2b5-8a4a-448e-a4dd-06e5ed678ad1",
                      "label": "DD_PSA_MB_58",
                      "parentId": "a7ce860d-ffd6-43db-8a0c-544506c88b03",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 122.825
                    },
                    {
                      "id": "4a709215-a67a-418d-ad52-fe60b4c9365d",
                      "label": "DD_PSA_MB_59",
                      "parentId": "a7ce860d-ffd6-43db-8a0c-544506c88b03",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 110.909
                    },
                    {
                      "id": "e356363c-b2eb-44d6-8148-57f54c82feec",
                      "label": "DD_PSA_MB_63",
                      "parentId": "a7ce860d-ffd6-43db-8a0c-544506c88b03",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 112.733
                    }
                  ],
                  "count": 9.0,
                  "length": 0,
                  "area": 1151.026
                },
                {
                  "id": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                  "label": "Apartment building",
                  "parentId": "058adde8-f5ac-40a9-b41d-1534f2ec5055",
                  "children": [
                    {
                      "id": "61eb10e5-824f-465a-ad3f-7eec3860db99",
                      "label": "DD_PSA_AB_12",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 225.486
                    },
                    {
                      "id": "c54540d4-d492-4927-b4e6-38e63f0763a7",
                      "label": "DD_PSA_AB_14",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 137.73
                    },
                    {
                      "id": "47c5e842-3a5e-48ff-b857-6bbbad951141",
                      "label": "DD_PSA_AB_15",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 73.181
                    },
                    {
                      "id": "36b75b28-0475-4386-ba5c-ed3f616cf58c",
                      "label": "DD_PSA_AB_16",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 143.087
                    },
                    {
                      "id": "7fc21e27-8a57-402a-9f43-db088717eae1",
                      "label": "DD_PSA_AB_17",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 280.659
                    },
                    {
                      "id": "b51474be-1d8e-4f46-9dba-c52b522b5018",
                      "label": "DD_PSA_AB_20",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 133.734
                    },
                    {
                      "id": "af4d5286-c45e-4493-896a-ca7fb9fb6d53",
                      "label": "DD_PSA_AB_21",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 108.309
                    },
                    {
                      "id": "f8380e48-106d-4b2b-b4ce-cb4db1338f76",
                      "label": "DD_PSA_AB_26",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 117.009
                    },
                    {
                      "id": "e7207657-4832-4fa0-9989-a12d150dcf17",
                      "label": "DD_PSA_AB_27",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 164.978
                    },
                    {
                      "id": "4d5a01d9-f40e-4c6e-b3d4-4023ce110af2",
                      "label": "DD_PSA_AB_28",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 92.765
                    },
                    {
                      "id": "03b3a8e8-38af-4ceb-8068-5eac63b07e38",
                      "label": "DD_PSA_AB_29",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 114.879
                    },
                    {
                      "id": "700cf60c-570c-45b5-b036-0bb35062b321",
                      "label": "DD_PSA_AB_31",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 80.553
                    },
                    {
                      "id": "7ff174b1-e57c-4a0d-ba8c-8df1165af326",
                      "label": "DD_PSA_AB_32",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 81.493
                    },
                    {
                      "id": "f2fb8a78-e881-488e-be2b-4ff243690546",
                      "label": "DD_PSA_AB_33",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 124.51
                    },
                    {
                      "id": "d9a4e2b4-03fe-447e-aad1-a25d8a33ac0a",
                      "label": "DD_PSA_AB_34",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 124.42
                    },
                    {
                      "id": "1923f377-f097-41be-a53b-80ee3211ff13",
                      "label": "DD_PSA_AB_35",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 113.503
                    },
                    {
                      "id": "e66f2b55-aaa4-4ba2-8797-a99ef174824d",
                      "label": "DD_PSA_AB_36",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 213.697
                    },
                    {
                      "id": "fa896001-f4f8-4294-b306-4b8fe1148418",
                      "label": "DD_PSA_AB_37",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 106.972
                    },
                    {
                      "id": "0afac1e7-7076-4c7c-b807-1edfece32c99",
                      "label": "DD_PSA_AB_39",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 123.182
                    },
                    {
                      "id": "098ed993-6744-4100-9e49-ab68b176f77e",
                      "label": "DD_PSA_AB_40",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 102.886
                    },
                    {
                      "id": "f76c0add-1861-42fb-9202-2ad05a8b28f2",
                      "label": "DD_PSA_AB_41",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 105.818
                    },
                    {
                      "id": "bebd2857-7b6c-421d-9e3c-fed512d49e72",
                      "label": "DD_PSA_AB_42",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 111.62
                    },
                    {
                      "id": "7c2b92ae-6208-463b-ba5c-3efac12b6581",
                      "label": "DD_PSA_AB_43",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 105.844
                    },
                    {
                      "id": "e7097629-5acb-4c3c-8bf9-548ece74115b",
                      "label": "DD_PSA_AB_44",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 86.4
                    },
                    {
                      "id": "a66e5700-3de7-4e50-b0c4-00228a1b6382",
                      "label": "DD_PSA_AB_45",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 122.428
                    },
                    {
                      "id": "daa203b4-9ab1-47b3-8a5c-9a9fd7685ad2",
                      "label": "DD_PSA_AB_46",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 89.285
                    },
                    {
                      "id": "dc8edf49-b8bd-43bd-a6bf-a56ec43b82bb",
                      "label": "DD_PSA_AB_48",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 106.19
                    },
                    {
                      "id": "f0caca7a-16ea-4042-8cc3-037163e960e7",
                      "label": "DD_PSA_AB_49",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 113.435
                    },
                    {
                      "id": "fee478c7-aa00-4fb6-94cf-992139c6c72e",
                      "label": "DD_PSA_AB_51",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 92.0
                    },
                    {
                      "id": "68e3e5b7-a9c9-430b-8291-a6b50062b571",
                      "label": "DD_PSA_AB_56",
                      "parentId": "b7abbf8e-8a1c-4c47-8928-e94881e1d77a",
                      "children": [],
                      "count": 1.0,
                      "length": 0,
                      "area": 85.908
                    }
                  ],
                  "count": 30.0,
                  "length": 0,
                  "area": 3681.961
                }
              ],
              "count": 63.0,
              "length": 0,
              "area": 11531.272
            }
          ],
          "count": 63.0,
          "length": 0,
          "area": 11531.272
        }
      ];

    const silcharJanLayers = [
        {
          "id": "3abca377-4f5c-40b5-bb6b-ccd2d1920a5e",
          "label": "Building Footprints",
          "parentId": null,
          "children": [
            {
              "id": "16d0eca8-5ff9-4948-9a5e-36fa5e1e707b",
              "label": "Building",
              "parentId": "3abca377-4f5c-40b5-bb6b-ccd2d1920a5e",
              "children": [
                {
                  "id": "513efddc-cbab-4b03-9740-fbab0720cc15",
                  "label": "Independent Building",
                  "parentId": "16d0eca8-5ff9-4948-9a5e-36fa5e1e707b",
                  "children": [
                    {
                      "id": "9e83fb2d-5344-4205-96b7-00213a8f5a30",
                      "label": "DD_NS_IB_32",
                      "parentId": "513efddc-cbab-4b03-9740-fbab0720cc15",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 81.566
                    },
                    {
                      "id": "4da92d0b-7115-426f-ac89-830d04226cb5",
                      "label": "DD_NS_IB_33",
                      "parentId": "513efddc-cbab-4b03-9740-fbab0720cc15",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 38.137
                    }
                  ],
                  "count": 2,
                  "length": 0,
                  "area": 119.703
                }
              ],
              "count": 2,
              "length": 0,
              "area": 119.703
            }
          ],
          "count": 2,
          "length": 0,
          "area": 119.703
        }
      ];

    const silcharFeb1Layers = [
        {
          "id": "fca8e4f1-01f5-4b51-9587-fe6ccc546ccd",
          "label": "Building Footprints",
          "parentId": null,
          "children": [
            {
              "id": "da1d3e83-f4a8-4dd5-bbb6-1b3cd856968a",
              "label": "Building",
              "parentId": "fca8e4f1-01f5-4b51-9587-fe6ccc546ccd",
              "children": [
                {
                  "id": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                  "label": "Independent Building",
                  "parentId": "da1d3e83-f4a8-4dd5-bbb6-1b3cd856968a",
                  "children": [
                    {
                      "id": "fb0f7903-0ad6-41a2-a0ea-0571c02441b8",
                      "label": "DD_NS_IB_1",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 184.427
                    },
                    {
                      "id": "2136bb4a-4049-4837-8947-cb7045f91368",
                      "label": "DD_NS_IB_2",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 148.874
                    },
                    {
                      "id": "04fd4715-e3d2-4ec9-81e2-e83634b91b85",
                      "label": "DD_NS_IB_3",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 450.386
                    },
                    {
                      "id": "b662f783-eab4-4d7d-beec-7b195585b0cd",
                      "label": "DD_NS_IB_4",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 427.763
                    },
                    {
                      "id": "f31e765c-d8af-4f9b-8f2b-1d45c0f33911",
                      "label": "DD_NS_IB_5",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 393.849
                    },
                    {
                      "id": "666a3c3e-c0ad-4d85-80d8-0aab0028aebb",
                      "label": "DD_NS_IB_6",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 282.278
                    },
                    {
                      "id": "20c37202-e03b-425b-bea1-5b61c1e95ddd",
                      "label": "DD_NS_IB_7",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 243.585
                    },
                    {
                      "id": "c1a0fee2-cf05-417d-aa95-56bd232cf0d2",
                      "label": "DD_NS_IB_8",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 95.934
                    },
                    {
                      "id": "602715d4-af2b-4312-8fec-71df27175422",
                      "label": "DD_NS_IB_9",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 60.962
                    },
                    {
                      "id": "cd40b827-1ed1-4577-89b2-51191122c817",
                      "label": "DD_NS_IB_10",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 594.967
                    },
                    {
                      "id": "1af448c1-2c8e-409f-9430-5622e9a42472",
                      "label": "DD_NS_IB_11",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 468.145
                    },
                    {
                      "id": "ef954b0d-146b-4d3f-894e-f196bcd3cb23",
                      "label": "DD_NS_IB_12",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 385.314
                    },
                    {
                      "id": "2432f74e-acea-4254-a76a-fd844bd68372",
                      "label": "DD_NS_IB_13",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 321.35
                    },
                    {
                      "id": "6c7e17fa-32b3-4814-9f2d-06597d4afa0b",
                      "label": "DD_NS_IB_14",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 265.373
                    },
                    {
                      "id": "e7ef2496-b827-460c-8081-445c4c1da507",
                      "label": "DD_NS_IB_15",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 171.636
                    },
                    {
                      "id": "d11ba3f3-449c-4f4f-b700-aa5221a1cc24",
                      "label": "DD_NS_IB_16",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 145.56
                    },
                    {
                      "id": "24a0b58b-0aa3-4f85-96cf-453c45d235ef",
                      "label": "DD_NS_IB_17",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 437.617
                    },
                    {
                      "id": "c1705470-9dc3-42c1-9220-833a09892e48",
                      "label": "DD_NS_IB_18",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 388.434
                    },
                    {
                      "id": "8fe023fd-8f9c-4a54-9bf2-6b108e3d41f4",
                      "label": "DD_NS_IB_19",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 477.033
                    },
                    {
                      "id": "faf9510f-4b7c-45ca-90ef-82d25f67d06c",
                      "label": "DD_NS_IB_20",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 431.786
                    },
                    {
                      "id": "2f6f4578-a5a8-46bc-8dd1-b7aa06d143a6",
                      "label": "DD_NS_IB_21",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 361.969
                    },
                    {
                      "id": "a20a4f9b-410e-4227-9462-30a5cf7bc5b2",
                      "label": "DD_NS_IB_22",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 567.944
                    },
                    {
                      "id": "61009fe4-fc73-4726-88e2-980f8bc3b16f",
                      "label": "DD_NS_IB_23",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 374.939
                    },
                    {
                      "id": "27884e9f-f7e8-408a-960f-6bc9ff993257",
                      "label": "DD_NS_IB_24",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 589.087
                    },
                    {
                      "id": "27c972df-2831-483d-a4ed-f02bb579bc5f",
                      "label": "DD_NS_IB_25",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 311.67
                    },
                    {
                      "id": "459efea6-cb60-4f72-a6c9-13afb98591f7",
                      "label": "DD_NS_IB_26",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 476.251
                    },
                    {
                      "id": "d7b05471-d307-4c7f-a266-fac94500f4e1",
                      "label": "DD_NS_IB_27",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 338.096
                    },
                    {
                      "id": "610e15e6-f46a-47a0-ac99-5a6fc1a3f031",
                      "label": "DD_NS_IB_28",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 193.183
                    },
                    {
                      "id": "1c70743e-d2d2-4315-acbd-984b7b3564f6",
                      "label": "DD_NS_IB_29",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 558.022
                    },
                    {
                      "id": "d087f18b-ac24-45e0-9b1c-dd692df76177",
                      "label": "DD_NS_IB_30",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 127.672
                    },
                    {
                      "id": "182e47de-fdb3-4c5f-98cb-6dd720e36fee",
                      "label": "DD_NS_IB_31",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 24.203
                    },
                    {
                      "id": "52a84090-081f-4d25-bc20-e870319983c0",
                      "label": "DD_NS_IB_32",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 81.566
                    },
                    {
                      "id": "f1e43c92-7a5d-4142-a276-5c3262952c99",
                      "label": "DD_NS_IB_33",
                      "parentId": "b4a4c3be-0109-445b-857d-388db7ef7f7e",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 38.137
                    }
                  ],
                  "count": 33,
                  "length": 0,
                  "area": 10418.012
                }
              ],
              "count": 33,
              "length": 0,
              "area": 10418.012
            }
          ],
          "count": 33,
          "length": 0,
          "area": 10418.012
        }
      ];

    const silcharFeb2Layer = [
        {
          "id": "e39c3139-715d-46c3-ae1f-40d1d4287fec",
          "label": "Building Footprints",
          "parentId": null,
          "children": [
            {
              "id": "c297f08e-a44d-47ff-bfef-5aa4b3fc4d5b",
              "label": "Building",
              "parentId": "e39c3139-715d-46c3-ae1f-40d1d4287fec",
              "children": [
                {
                  "id": "96261912-5588-4fcd-8a31-3530a61013df",
                  "label": "Independent Building",
                  "parentId": "c297f08e-a44d-47ff-bfef-5aa4b3fc4d5b",
                  "children": [
                    {
                      "id": "c93805af-1703-4570-b03c-9a05acc6ec20",
                      "label": "DD_NS_IB_1",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 184.427
                    },
                    {
                      "id": "17be46f9-4b04-49d5-a16c-60d8076b5295",
                      "label": "DD_NS_IB_2",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 148.874
                    },
                    {
                      "id": "c1a77c4b-8441-49e4-a9e1-ff0dd304b530",
                      "label": "DD_NS_IB_3",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 450.386
                    },
                    {
                      "id": "13dee972-0772-4ae5-af8a-ff34f84fe8d1",
                      "label": "DD_NS_IB_4",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 427.763
                    },
                    {
                      "id": "d877123b-3799-442a-8e7d-b60979bd879c",
                      "label": "DD_NS_IB_5",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 393.849
                    },
                    {
                      "id": "a76e9788-5e04-4e61-a4d6-793886b53f31",
                      "label": "DD_NS_IB_6",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 282.278
                    },
                    {
                      "id": "b07ae490-9930-4ee5-aea8-a0aae57b23c1",
                      "label": "DD_NS_IB_7",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 243.585
                    },
                    {
                      "id": "400f4c02-ac81-45ce-9356-20993fc7caa4",
                      "label": "DD_NS_IB_8",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 95.934
                    },
                    {
                      "id": "160a3031-fbbf-4cd2-a15e-6e808f36ebf8",
                      "label": "DD_NS_IB_9",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 60.962
                    },
                    {
                      "id": "2626c052-c5c1-4ed4-bd87-93455ccc56a4",
                      "label": "DD_NS_IB_10",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 594.967
                    },
                    {
                      "id": "ebdec26c-9d7e-4fbc-970e-584ece14ff5e",
                      "label": "DD_NS_IB_11",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 468.145
                    },
                    {
                      "id": "0c936cdf-1288-49a7-8224-f00e85adc2a6",
                      "label": "DD_NS_IB_12",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 385.314
                    },
                    {
                      "id": "2c7fc8c6-ac4d-4fa7-8c04-4a94357c4248",
                      "label": "DD_NS_IB_13",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 321.35
                    },
                    {
                      "id": "ea9a97ea-5d5e-4f33-a6ad-becd1c10f03b",
                      "label": "DD_NS_IB_14",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 265.373
                    },
                    {
                      "id": "46f6b66b-277f-4468-abcb-68e90cd8be73",
                      "label": "DD_NS_IB_15",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 171.636
                    },
                    {
                      "id": "0eecd43f-a9af-4695-a60a-3cbeceaf5517",
                      "label": "DD_NS_IB_16",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 145.56
                    },
                    {
                      "id": "35584897-29a5-48bb-9e15-502044e137fc",
                      "label": "DD_NS_IB_17",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 437.617
                    },
                    {
                      "id": "5c032e97-a149-4619-a8c9-97632b003fe7",
                      "label": "DD_NS_IB_18",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 388.434
                    },
                    {
                      "id": "0990be5c-4a7b-4a53-a4e7-3febcc06e87c",
                      "label": "DD_NS_IB_19",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 477.033
                    },
                    {
                      "id": "c6066a6b-a6e5-4a43-afa7-fe35f1101cf0",
                      "label": "DD_NS_IB_20",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 431.786
                    },
                    {
                      "id": "b67a419c-fbc7-46ea-9642-e33465870a73",
                      "label": "DD_NS_IB_21",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 361.969
                    },
                    {
                      "id": "eb3f9118-9c99-45f3-9d11-b5ffd5a6fc2b",
                      "label": "DD_NS_IB_22",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 567.944
                    },
                    {
                      "id": "f846a8cb-54b5-4e92-87f1-60295701b709",
                      "label": "DD_NS_IB_23",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 374.939
                    },
                    {
                      "id": "ebe3af13-8088-4ff4-b1bc-8feeb2563e45",
                      "label": "DD_NS_IB_24",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 589.087
                    },
                    {
                      "id": "b9557757-54cb-42da-89da-1b8285a43997",
                      "label": "DD_NS_IB_25",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 311.67
                    },
                    {
                      "id": "121e322f-5bd9-4161-a86b-78836c5aca4a",
                      "label": "DD_NS_IB_26",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 476.251
                    },
                    {
                      "id": "0dac71b5-dedf-4ee8-be4b-59e6d0368f72",
                      "label": "DD_NS_IB_27",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 338.096
                    },
                    {
                      "id": "2ecc5b39-4fe7-4215-be54-7461bfd6411e",
                      "label": "DD_NS_IB_28",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 193.183
                    },
                    {
                      "id": "ce7a5c4b-319f-41ae-a89d-5c8508f8d366",
                      "label": "DD_NS_IB_29",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 558.022
                    },
                    {
                      "id": "48b75141-6bab-4dea-8aad-325c1fe5956e",
                      "label": "DD_NS_IB_30",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 127.672
                    },
                    {
                      "id": "09a1ab6b-5b5e-4498-aabd-d0787b1fb004",
                      "label": "DD_NS_IB_31",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 24.203
                    },
                    {
                      "id": "d773c0f1-3c36-4b10-a52d-d1471d0fb253",
                      "label": "DD_NS_IB_32",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 81.566
                    },
                    {
                      "id": "72ed5d1b-f412-44d1-9686-0611b2d86607",
                      "label": "DD_NS_IB_33",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 38.137
                    },
                    {
                      "id": "0a68194e-5736-4bca-b8e7-f02651c80633",
                      "label": "DD_NS_IB_34",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 145.38
                    },
                    {
                      "id": "2462192b-27bd-4961-ac7d-b947aa489f08",
                      "label": "DD_NS_IB_35",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 131.12
                    },
                    {
                      "id": "b32996b8-7cdf-456d-af4b-6181164e36c7",
                      "label": "DD_NS_IB_36",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 75.182
                    },
                    {
                      "id": "d8160016-5b1f-4087-ad8b-cadddb6f47a7",
                      "label": "DD_NS_IB_37",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 595.606
                    },
                    {
                      "id": "60147c7e-ed14-4200-bbc4-da8d9509a34b",
                      "label": "DD_NS_IB_38",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 1215.871
                    },
                    {
                      "id": "e00ffcec-1de4-47a1-8475-041039b33da4",
                      "label": "DD_NS_IB_39",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 115.066
                    },
                    {
                      "id": "1b378e57-53b5-4a88-933e-9f4694b5801f",
                      "label": "DD_NS_IB_40",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 397.646
                    },
                    {
                      "id": "b1024108-94ae-43aa-9809-583ffa3c171f",
                      "label": "DD_NS_IB_41",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 183.8
                    },
                    {
                      "id": "93cd76b3-55cd-4447-b4bc-39880a77fac6",
                      "label": "DD_NS_IB_42",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 294.255
                    },
                    {
                      "id": "1e6271d5-4685-4c9b-855d-d78f72b97d96",
                      "label": "DD_NS_IB_43",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 934.212
                    },
                    {
                      "id": "977a825f-bec0-4e4a-b3b5-d436c6af2f53",
                      "label": "DD_NS_IB_44",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 494.349
                    },
                    {
                      "id": "26503a42-c799-4d30-a017-62c4ab84d06a",
                      "label": "DD_NS_IB_45",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 917.403
                    },
                    {
                      "id": "36e75074-63af-410e-9089-21f28b65b2cd",
                      "label": "DD_NS_IB_46",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 239.813
                    },
                    {
                      "id": "dcb7cd4d-2921-426c-9568-d14639ace3bc",
                      "label": "DD_NS_IB_47",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 247.288
                    },
                    {
                      "id": "f0943eba-a162-499f-b2e6-c82650bc0e69",
                      "label": "DD_NS_IB_48",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 228.068
                    },
                    {
                      "id": "d7c03d81-8d58-457d-b3db-d67cda4c4cb1",
                      "label": "DD_NS_IB_49",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 150.662
                    },
                    {
                      "id": "3a45a18e-0db5-49f2-be47-a8eb8fb4a5a3",
                      "label": "DD_NS_IB_50",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 309.374
                    },
                    {
                      "id": "ed142c80-24e7-4191-9290-ad9a1d0e3b66",
                      "label": "DD_NS_IB_51",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 115.232
                    },
                    {
                      "id": "ab2305c2-9b10-46de-a09c-86343318cabd",
                      "label": "DD_NS_IB_52",
                      "parentId": "96261912-5588-4fcd-8a31-3530a61013df",
                      "children": [],
                      "count": 1,
                      "length": 0,
                      "area": 57.625
                    }
                  ],
                  "count": 52,
                  "length": 0,
                  "area": 17265.963999999993
                }
              ],
              "count": 52,
              "length": 0,
              "area": 17265.963999999993
            }
          ],
          "count": 52,
          "length": 0,
          "area": 17265.963999999993
        }
      ];

    const [project, setProject] = useState('');
    const [aoi, setAoi] = useState('');
    const [date, setDate] = useState('');
    const [aois, setAois] = useState([]);
    const [dates, setDates] = useState([]);
    const [layers, setLayers] = useState([]);

    const handleProjectChange = (e) => {
        const p = e.target.value;
        setProject(p);
        setAoi("");
        setDate("");
        setLayers([]);
        const newAois = p == "area" ? ["Pune Suburban Area"] : ["Silchar"];
        setAois(newAois);
    };

    const handleAoiChange = (e) => {
        const a = e.target.value;
        setAoi(a);
        setDate("");
        setLayers([]);
        const newDates = a == "Pune Suburban Area" ? ["5/3/2025"] : ["1/28/2025", "2/4/2025", "2/8/2025"];
        setDates(newDates);
    };

    const handleDateChange = (e) => {
        const cdate = e.target.value;
        setDate(cdate);
        if(project == "area") {
            setLayers(puneLayers);
        } else if(cdate == "1/28/2025") {
            setLayers(silcharJanLayers);
        } else if(cdate == "2/4/2025") {
            setLayers(silcharFeb1Layers);
        } else if(cdate == "2/8/2025") {
            setLayers(silcharFeb2Layer);
        }
    };

    return <>
            <div className={styles.filterContainer}>
                <label className={styles.filtersLabel}>Project:&nbsp;</label>
                <select value={project} onChange={handleProjectChange} className="form-control">
                    <option value="">-- Select Project --</option>
                    <option key="area" value="area">Area LU Classify</option>
                    <option key="nhidcl" value="nhidcl">NHIDCL</option>
                </select>

                <label className={styles.filtersLabel}>AOI:&nbsp;</label>
                <select value={aoi} onChange={handleAoiChange} disabled={!project}  className="form-control">
                    <option value="">-- Select AOI --</option>
                    {aois.map((a) => <option key={a} value={a}>{a}</option>)}
                </select>

                <label className={styles.filtersLabel}>Date:&nbsp;</label>
                <select value={date} onChange={handleDateChange} disabled={!aoi} className="form-control">
                    <option value="">-- Select Date --</option>
                    {dates.map((d) => (
                    <option key={d} value={d}>{d}</option>
                    ))}
                </select>
            </div>
            {
                layers != null && layers.length > 0 && 
                <ExpandableTable data={layers}></ExpandableTable>
            }
            </>;
}

export default LayerSummary;